import React from 'react';

const AdminPage = () => {
  return(
    <h1>Admin page</h1>
  );
};

export default AdminPage;